import { isDateTodayOrLater } from '../../../dateHelpers';
import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../../PrismicHelpers';

export const eventsSlice = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;

    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        events: sliceRepetableData && sliceRepetableData.length > 0 && sliceRepetableData.map(event => {
            return event.event_id.id
        })
    };
    return dataToSend;
}

export const eventsSliceRelationship = (data, sliceType) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = sliceType;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const futureEvents = data.result && data.result.filter(event => isDateTodayOrLater(event.data.date))
    const sortedEvents = futureEvents && futureEvents.sort((a,b) => new Date(a.data.date) - new Date(b.data.date));
    const sliceRepetableData = sortedEvents;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        events: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(event => {
            return {
                image: UrlHelper(event.data.image),
                    uid: SmallTextHelper (event.id),
                    date: SmallTextHelper(event.data.date),
                    title: TextHelper(event.data.title),
                    description: TextHelper(event.data.description),
                    country: SmallTextHelper(event.data.country),
                    location: TextHelper(event.data.city),
                    url_eventbrite: UrlHelper(event.data.url_eventbrite),
            }
        })
    };
    return dataToSend
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/eventsSlice.js